import * as THREE from 'three';

export const appColors = {
    // Scene
    LIGHT_GREY: new THREE.Color(0xededed),
    MED_GREY: new THREE.Color(0xfcfcfcf),
    DARK_GREY: new THREE.Color(0x878686),
    BLACK: new THREE.Color(0x000000),
    BACKGROUND: new THREE.Color(0xf1f4f4),
    // BACKGROUND: new THREE.Color(0xf4f4f1),
    GRID_LINE_LIGHT: new THREE.Color(0xc9c9c9),
    GRID_LINE_DARK: new THREE.Color(0x919191),

    // Surfaces
    GROUND: new THREE.Color(0x00ff00),
    SURFACE_WHITE: new THREE.Color(0xffffff),
    SURFACE_HIGHLIGHT: new THREE.Color(0xe600e6),
    SURFACE_HOVER: new THREE.Color(0xdbbddb),

    // Lines
    OUTLINE: new THREE.Color(0x262626),
    DIMENSION_LINE: new THREE.Color(0xe600e6),
    SUNPATH_LINE: new THREE.Color(0xe600e6),
    PIPE_LINE: new THREE.Color(0xf07d60),
    PIPE_LINE_HIGHLIGHT: new THREE.Color(0xe600e6),
    DUCT_LINE: new THREE.Color(0x3f13ed),

    // Graphs
    HEATING_1: '#CB6D69',
    HEATING_2: '#d68a87',
    HEATING_3: '#dba7a4',
    HEATING_4: '#e8c3c1',
    COOLING_1: '#82B2D9',
    COOLING_2: '#9bc1e0',
    COOLING_3: '#afcbe3',
    GREEN_1: '#d3d19d',
    GREEN_2: '#a3c087',
    GREEN_3: '#6ab07d',
    GREEN_4: '#529c66',
    GREEN_5: '#3b824e',
};
